import { combineReducers } from "redux"

import listReducer from "./list/reducer"

export const authorsStateReducer = combineReducers({
  list: listReducer,
})
export { default as authorEntitiesReducer } from "./entities/reducer"
